import { decodeToken } from "./decodeToken";

/**
 * Checks if the token is expired.
 * @returns {boolean} - Returns true if the token is expired, otherwise false.
 */
export const isTokenExpired = () => {
  const token = localStorage.getItem("token");
  if (token === null || token === "") {
    return null; // No token means it's not expired or not present
  }

  const decodedToken = decodeToken(token);
  if (!decodedToken || !decodedToken.exp) {
    console.log("invalid token", decodedToken?.exp);
    return true; // Invalid token
  }

  const currentTime = Math.floor(Date.now() / 1000); // Current time in seconds
  console.log(
    "time",
    decodedToken.exp,
    currentTime,
    decodedToken.exp < currentTime
  );
  return decodedToken.exp < currentTime; // Check if the token is expired
};
